export default (initialState: any, handlers: Record<string, any>) =>
  (state = initialState, action: any) => {
    // eslint-disable-next-line no-prototype-builtins
    return (handlers as any).hasOwnProperty(action.type)
      ? (handlers as any)[action.type](state, action)
      : state;
  };
